import Animation from './Animation';
import './EnemyDie.css';
import fadeDeathClone from './deathClone';

export default class EnemyDie extends Animation {

	constructor (master, entity) {

		super(master, 1800, true);
		this.entity = entity;
	}

	run () {

		const entity = document.querySelector("#game-entity-" + this.entity);
		fadeDeathClone(entity, this.time);
		this.async();
	}
}
